export default {
    PASSWORD_POLICY_SAVED_SUCCESSFULLY: "Парольная политика успешно обновлена"
};
